import { defineNuxtPlugin } from 'nuxt/app'
import posthog from 'posthog-js'
import { useStore } from 'vuex'

// Make sure that pageviews are captured with each route change
export default defineNuxtPlugin((_app) => {
  const router = useRouter()
  const store = useStore()
  const runtimeConfig = useRuntimeConfig()

  const posthogInitAndInject = (promoterOid, userProperties) => {
    const _posthogClient = posthog.init(runtimeConfig.public.arPosthogApiKey, {
      api_host: runtimeConfig.public.arPosthogUrl,
      capture_pageview: false, // we add manual pageview capturing below
      loaded: (posthog) => {
        posthog.identify(promoterOid, userProperties)
      },
    })
  }

  // Determine if user is logged in
  const isLoggedIn = (auth) => {
    if (!auth || !auth.account || !auth.account.promoterOid)
      return false

    return true
  }

  // Check if Promoter is part of the allowed list for session recordings
  // List is set as an ENV VAR in Netlify
  const isAllowedPromoter = (promoterOid) => {
    if (!promoterOid)
      return false

    if (runtimeConfig.public.arPosthogAllowedPromoters === '')
      return false

    // include is type strict
    const arPosthogAllowedPromotersArr = runtimeConfig.public.arPosthogAllowedPromoters.split(',')

    if (!arPosthogAllowedPromotersArr.includes(promoterOid.toString()))
      return false

    return true
  }

  // Get and set properties of logged in user (i.e company name, email address etc)
  // It allows us to add as user properties to PostHog for filter ability
  // Posthog identify() method accepts object in 2nd parameter for properties
  const setUserProperties = (auth) => {
    let userProperties = {}
    if (auth && auth.account && auth.account.companyName)
      userProperties.companyName = auth.account.companyName
    if (auth && auth.account && auth.account.emailAddress)
      userProperties.emailAddress = auth.account.emailAddress
    if (auth && auth.account && auth.account.firstName)
      userProperties.firstName = auth.account.firstName
    if (auth && auth.account && auth.account.lastName)
      userProperties.lastName = auth.account.lastName

    return userProperties
  }

  router.afterEach((to) => {
    const auth = computed(() => store.state.authModule)
    const authValue = auth.value

    // Ensure user is logged in
    if (!isLoggedIn(authValue))
      return

    // Only for specific Promoters
    if (!isAllowedPromoter(authValue.account.promoterOid))
      return

    let userProperties = setUserProperties(authValue)

    // Init posthog
    // At this stage, authValue.account.promoterOid already exist as it will fail at isLoggedIn above
    posthogInitAndInject(authValue.account.promoterOid, userProperties)

    nextTick(() => {
      posthog.capture('$pageview', {
        current_url: to.fullPath,
      })
    })
  })

  return {
    provide: {
      posthog: () => posthogClient,
    },
  }
})
